// Rollbar configuration
export const rollbarConfig = {
  accessToken: '7472f81fe8cc4e39a0aa4936a4d07762',
  environment: import.meta.env.MODE,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      }
    }
  }
};
